import { MenuItem, Typography } from '@vapor/material'
import { Select } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import { CreditType } from 'src/api/api.generated'

type CreditSingleSelectProps = {
  value: CreditType
  onChange: (value: CreditType) => void
  disabled?: boolean
}

export default function CreditSingleSelect(props: CreditSingleSelectProps) {
  const { value, onChange, disabled } = props
  const { t } = useTranslation()
  return (
    <Select disabled={disabled} size="small" fullWidth value={value} onChange={(event) => onChange(event.target.value as CreditType)}>
      {Object.keys(CreditType).map((credit) => {
        return (
          <MenuItem key={credit} value={credit}>
            <Typography variant="body">{t(`pms.booking.reservation_new.options.credit.${credit as CreditType}`)}</Typography>
          </MenuItem>
        )
      })}
    </Select>
  )
}
